import React from 'react'
import { LabelData } from '../FreeDosageLayoutV2'
import { LabelColor } from 'data-types/src/LabelTypes';


export const getLabelColorClasses = (color: LabelColor): string => {
  switch (color) {
    case 'orange': return '#FF7A00';
    case 'red': return '#DE416A';
    case 'cyan': return '#29B8C7';
    case 'pink': return '#DC35A5';
    case 'yellow': return '#F5AF01';
    case 'purple': return '#6F42C1';
    default: return 'gray';
  }
};
const getLabelStyle = (color: string) => ({
  backgroundColor: color,
  boxShadow: `0 4px 6px -1px ${color}33`, // 33 is hex for ~20% opacity
  color: 'white'
});
type Props = {
    labelData:LabelData
    className?: string
}

const LabelCatalogTag:React.FC<Props> = ({labelData,className}) => {
  const hexColor = getLabelColorClasses(labelData.color);
  const bgCss ={ backgroundColor: hexColor };
  const shadowCss = getLabelStyle(hexColor)
  return (
  <div id='product-availability-tag' 
  style={{...bgCss,...shadowCss}}
  className={`flex items-center justify-center text-white text-center p-1 items-center justify-center
     h-[20px] text-[12px] w-[110px] rounded-[3px] shadow-lg font-poppins font-semibold
    shadow[${hexColor}]/20 ${className}`}
>
    {labelData.text}
  </div>
  
  )
}

export default LabelCatalogTag